"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * API V1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderItemToJSON = exports.OrderItemFromJSONTyped = exports.OrderItemFromJSON = exports.instanceOfOrderItem = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the OrderItem interface.
 */
function instanceOfOrderItem(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfOrderItem = instanceOfOrderItem;
function OrderItemFromJSON(json) {
    return OrderItemFromJSONTyped(json, false);
}
exports.OrderItemFromJSON = OrderItemFromJSON;
function OrderItemFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'productImage': !(0, runtime_1.exists)(json, 'product_image') ? undefined : json['product_image'],
        'productName': !(0, runtime_1.exists)(json, 'product_name') ? undefined : json['product_name'],
        'color': !(0, runtime_1.exists)(json, 'color') ? undefined : json['color'],
        'decorationMethod': !(0, runtime_1.exists)(json, 'decoration_method') ? undefined : json['decoration_method'],
        'totalQuantity': !(0, runtime_1.exists)(json, 'total_quantity') ? undefined : json['total_quantity'],
        'unitPrice': !(0, runtime_1.exists)(json, 'unit_price') ? undefined : json['unit_price'],
        'sizes': !(0, runtime_1.exists)(json, 'sizes') ? undefined : json['sizes'],
    };
}
exports.OrderItemFromJSONTyped = OrderItemFromJSONTyped;
function OrderItemToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'product_image': value.productImage,
        'product_name': value.productName,
        'color': value.color,
        'decoration_method': value.decorationMethod,
        'total_quantity': value.totalQuantity,
        'unit_price': value.unitPrice,
        'sizes': value.sizes,
    };
}
exports.OrderItemToJSON = OrderItemToJSON;
